<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  widget: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const content = computed(
  () => props.widget.props?.content || 'Double-cliquez pour éditer le contenu'
);
const title = computed(() => props.widget.props?.title);
const fontSize = computed(() => {
  const sizes = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl',
  };
  return sizes[props.widget.props?.fontSize] || 'text-base';
});
const alignment = computed(() => {
  const aligns = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };
  return aligns[props.widget.props?.alignment] || 'text-left';
});
</script>

<template>
  <div class="h-full flex flex-col font-inter group">
    <div v-if="title" class="mb-4 flex items-center justify-between px-1">
      <div class="flex items-center gap-3">
        <div
          class="flex h-7 w-7 items-center justify-center rounded-lg bg-slate-50 border border-slate-100 text-slate-400 group-hover:text-slate-900 group-hover:bg-white transition-all duration-200"
        >
          <span class="i-lucide-file-text h-3.5 w-3.5" />
        </div>
        <h3 class="text-[13px] font-bold text-slate-900 tracking-tight">
          {{ title }}
        </h3>
      </div>
    </div>
    <div
      class="whitespace-pre-wrap flex-1 text-slate-600 font-medium leading-relaxed p-5 rounded-xl border border-slate-100 bg-slate-50/30 group-hover:bg-white group-hover:border-slate-200 transition-all duration-300"
      :class="[fontSize, alignment]"
    >
      {{ content }}
    </div>
  </div>
</template>
